import { makeStyles } from '@material-ui/styles';
import { Sidebar, Topbar } from './components';
import '../../content/assets/vendor/fontawesome/css/all.min.css';
import '../../content/assets/vendor/bootstrap/css/bootstrap.min.css';
import '../../content/assets/css/style-min.css';
import '../../content/assets/vendor/datetimepicker/jquery.datetimepicker.css';
import NewFooter from './components/Footer/NewFooter';
import { FaceRegisterPrompt } from 'components/UserInfo';
//import "../../content/assets/vendor/magnific-popup/magnific-popup.css";

const useStyles = makeStyles(() => ({
  // root: {
  //   paddingTop: 64,
  //   height: '100%'
  // },
  // content: {
  //   height: '100%'
  // }
}));

const Main = (props) => {
  const { children } = props;
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Sidebar />

      {/* Main content */}
      <div className="main-content">
        <div
          className="loader"
          style={{
            margin: '20px',
            display: 'none',
            position: 'fixed',
            zIndex: '100000'
          }}></div>
        <div className="inner">
          {
            // trang thi không active menu sidebar
            //window.location.pathname == "/thi" || window.location.pathname == "/thi-thpt-2025" ? "" : <Topbar />
            <Topbar />
          }
          {children}
        </div>
        <NewFooter />
      </div>

      {/* <main>{children}</main> */}
      <FaceRegisterPrompt />
    </div>
  );
};

Main.propTypes = {
  //children: PropTypes.node,
  //className: PropTypes.string
};

export default Main;
